module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_18.abd1cf82.mp3";